import {AddressInputProps} from '../components/address-input';

export const getAddressInput =
  <T>(data: Omit<AddressInputProps<T>, 'type'>) =>
  (): AddressInputProps<T> =>
    ({
      ...data,
      type: 'address-input',
    } as AddressInputProps<T>);
